export const GET_GALLERY_IRIS_CONTENT_BY_ID_SUCCESS = 'GET_GALLERY_IRIS_CONTENT_BY_ID_SUCCESS';
export const GET_GALLERY_IRIS_GRID_CONTENT = 'GET_GALLERY_IRIS_GRID_CONTENT'; // eslint-disable-line
export const GET_GALLERY_IRIS_SEO_CONTENT = 'GET_GALLERY_IRIS_SEO_CONTENT';
export const IRIS_INITIAL_CALL_MODE = 'IRIS_INITIAL_CALL_MODE';
export const SET_IRIS_ALT_MESSAGE = 'SET_IRIS_ALT_MESSAGE';
